<!--
 * @Author: cn1994
 * @Date: 2024-11-21 15:13:27
 * @LastEditors: cn1994
 * @LastEditTime: 2025-04-07 16:07:03
 * @Description: file content
-->
<!-- 气泡提示组件 components/CustomTooltip.vue -->
<template>
  <!-- 如果内容长度超过12个字符，则显示Tooltip -->
  <el-tooltip placement="top-start" :disabled="!isLongContent" :open-delay="300" :popper-class="popperClass">
    <div slot="content" class="el-tooltip-content max-w-[420px] max-h-[160px] overflow-auto">
      <div>{{ content }}</div>
    </div>
    <div
      class="ls-tooltip-title"
      :class="{'text-[#007aff]' : toJump, 'ellipsis-2' : rowsNumber == 2, 'ellipsis-1' : rowsNumber == 1, 'cursor-pointer': showHand}"
      @click="click"
    >
      <template v-if="keyValue">
        <span :class="{'text-[#007aff]': isBlue(fItem)}" v-for="fItem in content" >{{ fItem }}</span>
      </template>
      <span v-else>{{ content }}</span>
    </div>
  </el-tooltip>
</template>

<script>
import { getBytes } from "@/utils/index";
export default {
  props: {
    //展示的内容
    content: {
      type: String,
      required: true,
    },
    //传递的整个对象，跳转时使用
    row: {
      type: Object,
      default: () => {
        return {};
      },
    },
    //是否有跳转
    toJump: {
      type: Boolean,
      default: false,
    },
    // 几行缩略（默认两行）
    rowsNumber: {
      type: Number,
      default: 2,
    },
    // 展示数量
    showNum: {
      type: Number,
      default: 24,
    },
    // 搜索关键字匹配, 如果关键字不需要高亮状态  则不传或传空
    keyValue: {
      type: String,
      default: '',
    },
    // 鼠标是否展示手状
    showHand: {
      type: Boolean,
      default: true,
    },
    // 自定义样式
    popperClass:{
      type: String,
      default: ''
    }
  },
  computed: {
    // 判断内容是否超过12个字符
    // 数组类型会传长度，有长度就根据长度，没有就按照内容的长度
    isLongContent() {
      return getBytes(this.content) > this.showNum;
    },
    isBlue() {
      return (font)=>{
        return this.keyValue.includes(font) || this.keyValue.toUpperCase().includes(font) || this.keyValue.toLowerCase().includes(font);
      }
    },
  },

  methods: {
    click() {
      this.$emit('click')
    }
  }
};
</script>
<style>
.ls-tooltip-title {
  word-break: break-all;
}
</style>
